/* eslint-disable import/prefer-default-export */
export const docAgentReportConfig = {
  agentName: "Document Quality Agent",
  title: "Document Quality Report",
  subtitle: "Document Quality Agent",
  backPath: "/doc-agent",
};
